import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { MenuItem, TextField } from '@material-ui/core'
import { useWizardFormContext } from 'components/wizard-form/context'
import FormControl from '@material-ui/core/FormControl'

const AcademySelect = () => {
  const { errors, control } = useFormContext()
  const {
    extraData: { coachAcademies },
  } = useWizardFormContext()

  return (
    <FormControl error={!!errors.locationId} variant="outlined" fullWidth>
      <Controller
        name="academyId"
        control={control}
        render={({ onChange, value }, _) => (
          <TextField
            select
            label="Section"
            variant="outlined"
            defaultValue={coachAcademies[0].id}
            onChange={onChange}
            value={value}
          >
            {coachAcademies.map(academy => (
              <MenuItem key={academy.id} value={academy.id}>
                {academy.name}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
    </FormControl>
  )
}

export default AcademySelect
